<script setup lang="ts">
import { ProfilePage } from '@yc/ui-kit'

import ChangePwdForm from '../components/ChangePwdForm.vue'
</script>

<!-- 个人信息卡与页面骨架在 ui-kit 的 ProfilePage 里；portal 的改密表单带 redirectAfter，
     改密成功后跳回 redirect 参数指向的页面，与子系统那份（脚手架生成的）不是同一个组件。 -->
<template>
  <ProfilePage>
    <ChangePwdForm />
  </ProfilePage>
</template>